export const jurisdictionOptions = [
  {
    value: '1.1',
    label: 'Decomisadas',
  },
  {
    value: '1.2',
    label: 'EXPR. ABANDONADAS'
  },
  {
    value: '1.3',
    label: 'C/CAUSA LEGAL PENDIENTE'
  },
  {
    value: '2.1',
    label: 'PRESUNCIÓN ABANDONO'
  },
  {
    value: '2.3',
    label: 'SOBRESIEM. DE JUICIO'
  },
  {
    value: '2.4',
    label: 'ALMACÉN EMPORCHI'
  },
  {
    value: '2.5',
    label: 'S/ANTEC. ALMAC. AD.'
  },
  {
    value: '2.6',
    label: 'S/ANTEC. ALM. EMPOR'
  },
  {
    value: '2.8',
    label: 'DEPOS. REC. PART.'
  },
  {
    value: '2.9',
    label: 'S/ANTEC. ALM. PART.'
  }
];

export const validations = {
  abandon: '2.1',
  pending: '1.3',
  resolution: ['1.1', '2.3', '2.4', '2.5', '2.6', '2.8', '2.9', '1.2'],
  service: ['1.1', '2.3', '2.4', '2.5', '2.6', '2.8', '2.9'],
  confiscation: '1.1'
};
